import { ICarrierApplicationStates } from 'types/FMSGraphqlTypes'
import { ISetupGuideInfoQuery } from '../graphql/SetupGuideInfo'

const SETUP_GUIDE_STATES = [
  ICarrierApplicationStates.expired_insurance,
  ICarrierApplicationStates.application_submitted,
  ICarrierApplicationStates.new,
  ICarrierApplicationStates.in_review,
]

export const isUsersMotorCarriersSetupComplete = (
  motorCarriers: ISetupGuideInfoQuery['motorCarriersForUser']
): Boolean => {
  return !motorCarriers.some(({ state }) => !state || SETUP_GUIDE_STATES.includes(state))
}
